<template>
  <div class="culture">
    <top-nav></top-nav>
    <banner  :bgImage="bgImage"></banner>
    <section class="corporationVision">
      <div class="aboutReyzarBox">
        <div class="aboutReyzarTit">
          <div class="aboutReyzarTitTop">企业愿景</div>
          <div class="aboutReyzarTitMid">CORPORATION&nbsp;&nbsp;VISION</div>
          <div class="aboutReyzarTitButtom">
            中国下一代互联网的布道者与开拓者&nbsp;&nbsp;&nbsp;&nbsp;邀请您共同开启下一代互联网新时代
          </div>
        </div>
        <div class="companyCultureFlex">
          <ul class="clearfix">
            <li>
              <img src="../../../static/images/visionPic1.jpg" />
              <div class="companyCultureTit">国际化视野</div>
            </li>
            <li>
              <img src="../../../static/images/visionPic2.jpg" />
              <div class="companyCultureTit">持续化创新</div>
            </li>
            <li>
              <img src="../../../static/images/visionPic3.jpg" />
              <div class="companyCultureTit">差异化产品</div>
            </li>
            <li>
              <img src="../../../static/images/visionPic4.jpg" />
              <div class="companyCultureTit">多元化服务</div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="companyCulturePic">
      大国崛起&nbsp;华夏生辉&nbsp;睿哲科技欣逢盛世&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;战略聚焦&nbsp;持续投入&nbsp;睿哲科技虔诚布道
    </section>
    <section class="corporationCulture">
      <div class="aboutReyzarBox">
        <div class="aboutReyzarTit">
          <div class="aboutReyzarTitTop">企业文化</div>
          <div class="aboutReyzarTitMid">CORPORATION&nbsp;CULTURE</div>
          <div class="aboutReyzarTitButtom">
            因专注而专业&nbsp;&nbsp;&nbsp;&nbsp;因专业成就品牌
          </div>
        </div>
        <div class="companyCultureFlex">
          <ul class="clearfix">
            <li>
              <img src="../../../static/images/culturePic1.jpg" />
              <div class="companyCultureTit">积极创新</div>
            </li>
            <li>
              <img src="../../../static/images/culturePic2.jpg" />
              <div class="companyCultureTit">虔诚布道</div>
            </li>
            <li>
              <img src="../../../static/images/culturePic3.jpg" />
              <div class="companyCultureTit">追求卓越</div>
            </li>
            <li>
              <img src="../../../static/images/culturePic4.jpg" />
              <div class="companyCultureTit">携手共进</div>
            </li>
          </ul>
        </div>
        <div class="companyCultureConn">
          <p>
            睿哲玄览，都兹羊城，自创立以来，历经风雨、不畏艰险，睿哲以“积极创新
            虔诚布道 追求卓越
            携手共进”的企业精神和文化，实现了公司规模和品牌的超常规、跨越式发展，成为中国资本市场专注于下一代互联网的第一股。
          </p>
          <p>
            扎根中国，放眼全球，睿哲已进入“多元+规模+品牌”战略发展阶段，矢志成为科技行业具广泛影响力的国际顶级企业。因专注而专业，因专业成就品牌。在这充满挑战也孕育希望的互联网经济时代，睿哲义不容辞地担当起布道者和开拓者的双重责任，为国家下一代互联网的发展添砖加瓦。
          </p>
          <p>雄关漫道，羽扇纶巾，让我们携手共进。</p>
        </div>
      </div>
    </section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "culture",
  data() {
    return {
      bgImage:'../../../static/images/cultureBanner.png?0223',
      jobValue: 0,
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
.culture {
  .companyCultureFlex {
    width: 100%;
    height: auto;
    li {
      width: 280px;
      height: auto;
      float: left;
      margin-right: 26px;
      &:last-of-type {
        margin-right: 0;
      }
      img {
        width: 280px;
        display: block;
      }
      .companyCultureTit {
        width: 100%;
        line-height: 24px;
        font-size: 24px;
        text-align: center;
        padding-top: 25px;
      }
    }
  }
  .companyCulturePic {
    width: 1200px;
    height: 120px;
    margin: 0 auto;
    line-height: 120px;
    text-align: center;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
    text-shadow: 1px 1.732px 4px rgba(14, 5, 9, 0.75);
    background: url("../../../static/images/companyCulturePic.jpg") no-repeat
      center;
  }
  .companyCultureConn {
    width: 100%;
    height: auto;
    padding-top: 60px;
    p {
      font-size: 18px;
      text-align: justify;
      line-height: 32px;
      text-indent: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/culture/culture.vue